import script from "./ClientCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientCard.vue?vue&type=script&setup=true&lang=ts"

import "./ClientCard.vue?vue&type=style&index=0&id=acb2e2c0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acb2e2c0"]])

export default __exports__